// extracted by mini-css-extract-plugin
export var bg = "backdrop-module--bg--R0ZgV";